import axios from "axios";
import React, { useState, useContext } from "react";
import { useEffect } from "react";
import {
  ContListcategories,
  HeaderListCategories,
  BodyListCategories,
  FooterListCategories,
  ListCategories,
  ItemListCategories,
  ContLabelItem,
  ContIconOpenSubList,
  SubListCategories,
  ContbtnAddCategoryToLink,
  BtnAddToList,
} from "../../../../../../assets/css/components/admin/categories/LinkCategories";
import { Text } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/GridListProducts/GridListProducts";
import { BiCaretDown } from "react-icons/bi";
import MassiveScrapingCss from "../../../../../../assets/css/components/admin/products/amazon/MassiveScrapingCss";
import { useRef } from "react";
import { GlobalContext } from "../../../../../../contexts/GlobalContext";
import Pager from "../../../../../general/Pager";
import { LoadingSpinner } from "../../views/DetailProductMTM";
import { getAllCategoriesFalabella } from "../../../../categories/functions/getAllCategoriesFalabella";

export default function SelectFlCategory({
  setCategory,
  isLoad,
  setIsLoad,
  currentStep,
  setCurrentStep,
}) {
  const pageItemCount = 20;
  const globalContext = useContext(GlobalContext);
  const [totalCategories, setTotalCategories] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [filterTSearch, setFilterTSearch] = useState("");
  const urlRef = useRef(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  /**
   * Handle the axios error
   * @param {Error} err The thrown error
   * @param {string} msg A message to show in the modal
   * @param {boolean} consoleLog If should log the error in the console
   */
  const handleAxiosError = (err, msg = null, consoleLog = true) => {
    if (axios.isCancel(err)) return; //Don't show axios cancel error
    if (err.response && err.response.data) {
      if (err.response.data.message) {
        globalContext.showModalWithMsg(err.response.data.message);
      } else {
        globalContext.showModalWithMsg(err.response.data);
      }
    } else if (msg) {
      globalContext.showModalWithMsg(msg);
    }

    if (consoleLog) console.log("Error: ", err, "Response: ", err.response);
  };

  const setFilterToPublish = (e) => {
    e.preventDefault();
    setFilterTSearch(filter);
  };

  useEffect(() => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) return;

    setIsLoad(true);
    getAllCategoriesFalabella(entId, axiosCancelTokenSource)
      .then((r) => {
        // Ya viene como árbol desde getAllCategoriesFalabella
        const treeCategories = r.data.data;
        setCategories(treeCategories || []);
        setTotalCategories((treeCategories && treeCategories.length) || 0);
        setIsLoad(false);
      })
      .catch((e) => {
        console.log(e);
        handleAxiosError(e, "Error al cargar las categorías de Falabella");
        setIsLoad(false);
      });

    return () => {
      axiosCancelTokenSource.cancel();
    };
  }, [currentPage, filterTSearch, globalContext.currentEnterpriseId]);

  // Función para filtrar categorías de forma recursiva en todo el árbol
  const filterCategories = (categories, searchTerm) => {
    if (!searchTerm) return categories;

    const searchLower = searchTerm.toLowerCase();

    // Busca en el nombre y en cualquier hijo
    const filterNode = (node) => {
      const nodeClone = { ...node };
      let match = nodeClone.name.toLowerCase().includes(searchLower);
      let filteredChildren = [];
      if (nodeClone.children && nodeClone.children.length > 0) {
        filteredChildren = nodeClone.children
          .map(child => filterNode(child))
          .filter(Boolean);
        if (filteredChildren.length > 0) {
          nodeClone.children = filteredChildren;
          match = true; // Si algún hijo coincide, mostramos el padre
        }
      }
      return match ? nodeClone : null;
    };

    return categories.map(cat => filterNode(cat)).filter(Boolean);
  };

  const renderCategory = (category, level = 0) => {
    const isExpanded = expandedCategories.includes(category.categoryId);
    const hasChildren = category.children && category.children.length > 0;
    const isSelected = selectedCategoryId === category.categoryId;
    const paddingLeft = `${level * 20}px`;
    const isLeafNode = !hasChildren; // Es una categoría hoja si no tiene hijos

    return (
      <ItemListCategories key={category._id}>
        <ContLabelItem
          active={isSelected && isLeafNode}
          onClick={() => toggleCategory(category.categoryId, hasChildren)}
          style={{ paddingLeft }}
        >
          {category.name} - {category.categoryId}
          {hasChildren && (
            <ContIconOpenSubList active={isExpanded}>
              <BiCaretDown />
            </ContIconOpenSubList>
          )}
        </ContLabelItem>
        
        {isSelected && isLeafNode && (
          <ContbtnAddCategoryToLink j='flex-start'>
            <BtnAddToList onClick={() => setCategoryToPost(category)}>
              Seleccionar
            </BtnAddToList>
          </ContbtnAddCategoryToLink>
        )}
        
        {isExpanded && hasChildren && (
          <SubListCategories>
            {category.children.map(child => renderCategory(child, level + 1))}
          </SubListCategories>
        )}
      </ItemListCategories>
    );
  };

  const renderCategories = () => {
    const filteredCategories = filterCategories(categories, filter);
    return filteredCategories.map(category => renderCategory(category));
  };

  const toggleCategory = (categoryId, hasChildren) => {
    // Si tiene hijos, solo manejamos la expansión
    if (hasChildren) {
      setExpandedCategories(prev => 
        prev.includes(categoryId)
          ? prev.filter(id => id !== categoryId)
          : [...prev, categoryId]
      );
      return; // No permitimos seleccionar categorías con hijos
    }

    // Solo manejamos la selección para categorías hoja
    setSelectedCategoryId(prev => prev === categoryId ? null : categoryId);
  };

  const setCategoryToPost = (category) => {
    setCategory({
      id: category.categoryId,
      name: category.name,
      parentId: category.parent,
      globalIdentifier: category.globalIdentifier,
      attributes: category.attributes
    });
    setSelectedCategoryId(null);
    setCurrentStep(currentStep + 1);
  };

  return (
    <ContListcategories w='400px' mh='100vh'>
      <HeaderListCategories>
        <Text size='13pt' fw='bold' cl='#696969'>
          Categorias de Falabella
        </Text>
        <form style={{ width: "100%" }} onSubmit={setFilterToPublish}>
          <MassiveScrapingCss.inputOne
            placeholder='Buscar categoría...'
            type='text'
            onChange={(e) => setFilter(e.target.value)}
            ref={urlRef}
          />
        </form>
      </HeaderListCategories>
      <BodyListCategories>
        {isLoad ? (
          <LoadingSpinner />
        ) : (
          <ListCategories>
            {renderCategories()}
          </ListCategories>
        )}
      </BodyListCategories>
      <FooterListCategories>
        <Pager
          handleSetPage={setCurrentPage}
          totalResults={totalCategories}
          currentPage={currentPage}
          resultsPerPage={pageItemCount}
        />
      </FooterListCategories>
    </ContListcategories>
  );
}
